import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import {
  surveyEntryActionsRowCenteredSx,
  surveyEntryStartButtonSx,
} from '../styles/surveyEntryStyles'
import {
  signupShareSurveyStartButtonSx,
  useSignupShareTheme,
} from '../styles/signupShareTheme'

interface SurveyEntryActionsProps {
  readonly canStart: boolean
  readonly canContinue?: boolean
  readonly startPending: boolean
  readonly statusReady: boolean
  readonly statusLoading: boolean
  readonly onStartClick: () => void
  readonly onContinueClick?: () => void
}

export function SurveyEntryActions({
  canStart,
  canContinue = false,
  startPending,
  statusReady,
  statusLoading,
  onStartClick,
  onContinueClick,
}: SurveyEntryActionsProps) {
  let startLabel = 'Start Survey'
  if (startPending) {
    startLabel = 'Starting…'
  } else if (statusLoading) {
    startLabel = 'Loading…'
  }
  const startDisabled = startPending || !statusReady || !canStart
  const continueDisabled = startPending || !statusReady || !canContinue
  const signupTheme = useSignupShareTheme()
  const startButtonSx = signupTheme
    ? [surveyEntryStartButtonSx, signupShareSurveyStartButtonSx]
    : surveyEntryStartButtonSx

  return (
    <Box
      sx={surveyEntryActionsRowCenteredSx}
      data-testid="survey-entry-actions"
      data-survey-actions-centered="true"
    >
      {canContinue && onContinueClick ? (
        <Button
          variant="contained"
          disabled={continueDisabled}
          onClick={onContinueClick}
          sx={startButtonSx}
          data-testid="instrument-info-continue-survey"
        >
          Continue
        </Button>
      ) : null}
      <Button
        variant={canContinue ? 'outlined' : 'contained'}
        disabled={startDisabled}
        onClick={onStartClick}
        sx={startButtonSx}
        data-testid="instrument-info-start-survey"
        data-survey-start-accent={signupTheme ? 'signup' : 'default'}
      >
        {startPending ? <CircularProgress size={24} color="inherit" /> : startLabel}
      </Button>
    </Box>
  )
}
